import { useEventCallback, useLocalStorage } from "usehooks-ts";

/** Local-storage key: epoch milliseconds until which the banner stays hidden. */
export const NEW_LAYER_BANNER_SNOOZED_UNTIL_KEY =
  "layer.nextAppBannerSnoozedUntil";
/** How long one dismissal hides the banner before it comes back. */
export const NEW_LAYER_BANNER_SNOOZE_DAYS = 7;

const SNOOZE_DURATION_MS = NEW_LAYER_BANNER_SNOOZE_DAYS * 24 * 60 * 60 * 1000;

/** Whether a snooze lasting until `snoozedUntil` still hides the banner at `now`. */
export const isBannerSnoozed = (
  snoozedUntil: number | null,
  now: number,
): boolean => snoozedUntil != null && snoozedUntil > now;

/**
 * The banner's snooze state, shared by the banner itself and the app shell,
 * which offsets the nav drawer by the banner height. Dismissing the banner
 * hides it for NEW_LAYER_BANNER_SNOOZE_DAYS; after that it shows again.
 */
export const useNewLayerBannerSnooze = () => {
  const [snoozedUntil, setSnoozedUntil] = useLocalStorage<number | null>(
    NEW_LAYER_BANNER_SNOOZED_UNTIL_KEY,
    null,
  );

  const snooze = useEventCallback(() => {
    setSnoozedUntil(Date.now() + SNOOZE_DURATION_MS);
  });

  return { isSnoozed: isBannerSnoozed(snoozedUntil, Date.now()), snooze };
};
